<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="微信支付" name="first">
        <Wxpay></Wxpay>
      </el-tab-pane>
      <el-tab-pane label="支付宝支付" name="second">
        <Alipay></Alipay>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Alipay from "./Alipay.vue";
import Wxpay from "./Wxpay.vue";
export default {
  name: "payConfig",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    Alipay,
    Wxpay
  },
  created() {
  },
};
</script>